module.exports = __webpack_public_path__ + "assets/google-sign-in.52b4b344.svg";